import React from 'react';
import {
  Row,
  Col,
} from 'antd';

type Props = {
  slugName: String,
  bannerText: String,
  bannerImage: String,
  enableHOP: Boolean,
  storeOpen: Boolean,
  IndFlag: String,
  PakFlag: String,
};

const MobileHeader = (props: Props) => {
  const {
    slugName,
    bannerText,
    bannerImage,
    enableHOP,
    storeOpen,
    IndFlag,
    PakFlag,
  } = props;

  return (
    <Row
      justify="space-between"
      align="middle"
      // style={{ height: '20vh' }}
    >
      <Col span={24} className="d-flex justify-content-center align-items-center">
        <div className="d-flex align-items-center">
          <img
            src={(slugName && slugName === 'shasthafreshnewark') ?  'https://s3.amazonaws.com/assets-us1.swirepay.com/Mobile.png' : bannerImage}
            width='250'
            style={{
              margin: '10px 10px 0px 10px',
              height: '15vh',
              objectFit: 'contain',
            }}
          />
        </div>
      </Col>
      {
        bannerText ? (
          <Col span={24} className="d-flex justify-content-center align-items-center mt-2">
            <div className="d-flex align-items-center">
              <div className="info" style={{ lineHeight: '20px' }}>
                <strong style={{ color: (slugName && slugName === 't20worldcup') ? '#8c16e2' : '' }}>
                  <div dangerouslySetInnerHTML={{ __html: bannerText.replaceAll('<br>', '') }} />
                </strong>
              </div>
            </div>
          </Col>
        ) : (
          <></>
        )
      }
      {
        slugName && slugName === 't20worldcup' && (
          <Col span={24} className="d-flex justify-content-center align-items-center mt-2">
            <div className="d-flex align-items-center">
              <div className="info" style={{ lineHeight: '20px' }}>
                <strong>Cricket Fans Unite! </strong>
                <img src={IndFlag} alt="india" width="20" />
                <img src={PakFlag} alt="pak" width="33" />
              </div>
            </div>
          </Col>
        )
      }
      {
        slugName && slugName === 't20worldcup' && (
          <Col span={24} className="d-flex justify-content-center align-items-center mt-2">
            <div className="d-flex align-items-center">
              <div className="info" style={{ lineHeight: '20px' }}>
                <strong>Calling all cricket enthusiasts! The highly anticipated T20 World Cup match between India and Pakistan is happening on Jun 9th from 7:00 AM and it's going to be epic!</strong>
              </div>
            </div>
          </Col>
        )
      }
      {
        slugName && slugName === 't20worldcup' && (
          <Col span={24} className="d-flex justify-content-center align-items-center mt-2">
            <div className="d-flex align-items-center">
              <div className="info" style={{ lineHeight: '20px' }}>
                <strong>Join the Excitement!</strong>
              </div>
            </div>
          </Col>
        )
      }
      
      {
        (slugName && slugName === 'a2bplmenu') ? (
          <>
          </>
        ) : (
          <>
            {
              enableHOP && storeOpen ? (
                <Col span={24} className="d-flex justify-content-center align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="info" style={{ lineHeight: '30px' }}>
                      <></>
                      {/* <strong>Today's Online Ordering Hours:&nbsp; {timingsInfo && timingsInfo?.length > 0 ? getOperatingTime(timingsInfo[0].operatingHours[0].openingTime) : <>&#8211;</>} to{" "}
                        {timingsInfo && timingsInfo?.length > 0 ? getOperatingTime(timingsInfo[0].operatingHours[0].closingTime) : <>&#8211;</>}</strong> */}
                    </div>
                  </div>
                </Col>
              ) : (
                <>{
                  !storeOpen ? (
                    <Col span={24} className="d-flex justify-content-center align-items-center">
                      <div className="d-flex align-items-center">
                        <div className="info" style={{ lineHeight: '30px' }}>
                          <strong>Sorry, online orders are closed at the moment. Please check back during our opening hours.</strong>
                        </div>
                      </div>
                    </Col>
                  ) : (
                    <></>
                  )
                }</>
              )
            }
          </>
        )
      }
      
    </Row>
  );
};

export default MobileHeader;
